import React from "react";
import Header from "../Component/Header";
import { Link } from "react-router-dom";
import Footer from "../Component/Footer";
import LazyLoad from "react-lazyload";
import { useEffect } from "react";
const AdmissionDetails = () => {
  useEffect(() => {
    // Set the page title
    document.title = "Admission Details - Presentation Convent School Delhi";
  }, []);
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
          </li>
          <li> Admission </li>
          <li>Admission Details</li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1>Admission Details</h1>
            </div>
          </div>
          <div className="container">
            <div className="row g-3">
              <div className=" col-lg-4 col-md-4 col-sm-12">
                <div className=" admission_block">
                  <h3>LIST OF APPLICANTS SELECTED FOR KG ADMISSION 2026</h3>
                  <a
                    href="https://webapi.entab.info/api/image/PCSD/public/pdf/LIST-OF-APPLICANTS-SELECTED-FOR-KG-ADMISSION-2026.pdf"
                    target="_blank"
                  >
                    View Details
                  </a>
                </div>
              </div>
              <div className=" col-lg-4 col-md-4 col-sm-12">
                <div className=" admission_block">
                  <h3>
                    LIST OF APPLICANTS SELECTED FOR NURSERY ADMISSION 2026
                  </h3>
                  <a
                    href="https://webapi.entab.info/api/image/PCSD/public/pdf/LIST-OF-APPLICANTS-SELECTED-FOR-NURSERY-ADMISSION-2026.pdf"
                    target="_blank"
                  >
                    View Details
                  </a>
                </div>
              </div>
              <div className=" col-lg-4 col-md-4 col-sm-12">
                <div className=" admission_block">
                  <h3>SECOND LIST</h3>
                  <a href="https://webapi.entab.info/api/image/PCSD/public/pdf/SECOND-LIST.pdf" target="_blank">
                    View Details
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default AdmissionDetails;
